const rewardsTabTypes = {
    AVAILABLE: 'available',
    NOT_EARNED: 'notEarned',
    REDEEMED: 'redeemed',
};

export default rewardsTabTypes;
